import { defineComponent as _defineComponent } from 'vue';
import { createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Transition as _Transition } from "vue";
const _hoisted_1 = {
    id: "app",
    class: "min-h-screen bg-gray-50"
};
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" };
const _hoisted_3 = { class: "flex justify-between items-center h-16" };
const _hoisted_4 = { class: "flex items-center" };
const _hoisted_5 = { class: "hidden md:block" };
const _hoisted_6 = { class: "ml-10 flex items-baseline space-x-4" };
const _hoisted_7 = { class: "hidden md:flex items-center space-x-3" };
const _hoisted_8 = {
    key: 0,
    class: "flex items-center space-x-3"
};
const _hoisted_9 = { class: "flex items-center space-x-2" };
const _hoisted_10 = { class: "flex flex-col" };
const _hoisted_11 = { class: "text-sm text-gray-700" };
const _hoisted_12 = { class: "text-xs text-gray-500" };
const _hoisted_13 = { class: "md:hidden" };
const _hoisted_14 = {
    key: 0,
    class: "md:hidden bg-white border-t border-gray-200"
};
const _hoisted_15 = { class: "px-2 pt-2 pb-3 space-y-1 sm:px-3" };
const _hoisted_16 = { class: "px-3 py-2 border-t border-gray-200" };
const _hoisted_17 = {
    key: 0,
    class: "space-y-3"
};
const _hoisted_18 = { class: "flex items-center space-x-3 p-3 bg-gray-50 rounded-lg" };
const _hoisted_19 = { class: "text-sm font-medium text-gray-900" };
const _hoisted_20 = { class: "text-xs text-gray-500" };
const _hoisted_21 = { class: "max-w-8xl mx-auto py-6 sm:px-6 lg:px-8" };
const _hoisted_22 = { class: "max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8" };
import { ref, onMounted } from 'vue';
import { Trophy, Menu, User } from '@element-plus/icons-vue';
import { useAuthStore } from '@/stores/auth';
import { ElMessage } from 'element-plus';
export default /*@__PURE__*/ _defineComponent({
    __name: 'App',
    setup(__props) {
        const mobileMenuOpen = ref(false);
        const authStore = useAuthStore();
        const navItems = [
            { path: '/', title: '首页', icon: 'House' },
            { path: '/tournaments', title: '赛事管理', icon: 'List' },
            { path: '/players', title: '选手管理', icon: 'User' },
            { path: '/venues', title: '场地管理', icon: 'Setting' },
        ];
        const handleLogin = () => {
            // 跳转到登录页面
            window.location.href = '/login';
        };
        const handleLogout = async () => {
            try {
                await authStore.logout();
            }
            catch (error) {
                console.error('登出失败:', error);
                ElMessage.error('登出失败，请重试');
            }
        };
        // 获取权限级别文本
        const getPermissionLevelText = (level) => {
            const levelMap = {
                'none': '无权限',
                'viewer': '查看者',
                'editor': '编辑者',
                'admin': '管理员'
            };
            return levelMap[level] || level;
        };
        onMounted(async () => {
            // 检查用户登录状态
            try {
                await authStore.checkAuth();
            }
            catch (error) {
                // 静默处理认证检查失败
                console.log('用户未登录或认证失败');
            }
        });
        return (_ctx, _cache) => {
            const _component_el_icon = _resolveComponent("el-icon");
            const _component_router_link = _resolveComponent("router-link");
            const _component_el_avatar = _resolveComponent("el-avatar");
            const _component_el_button = _resolveComponent("el-button");
            const _component_el_header = _resolveComponent("el-header");
            const _component_router_view = _resolveComponent("router-view");
            const _component_el_main = _resolveComponent("el-main");
            const _component_el_text = _resolveComponent("el-text");
            const _component_el_footer = _resolveComponent("el-footer");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createCommentVNode(" 顶部导航栏 "),
                _createVNode(_component_el_header, { class: "bg-white shadow-sm border-b border-gray-200 px-0" }, {
                    default: _withCtx(() => [
                        _createElementVNode("nav", _hoisted_2, [
                            _createElementVNode("div", _hoisted_3, [
                                _createCommentVNode(" Logo和标题 "),
                                _createElementVNode("div", _hoisted_4, [
                                    _createVNode(_component_router_link, {
                                        to: "/",
                                        class: "flex items-center space-x-3 no-underline"
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_icon, { class: "text-2xl text-primary-600" }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Trophy))
                                                ]),
                                                _: 1 /* STABLE */
                                            }),
                                            _cache[2] || (_cache[2] = _createElementVNode("span", { class: "text-xl font-bold text-gray-900" }, "\"学院杯\"乒乓球比赛", -1 /* CACHED */))
                                        ]),
                                        _: 1 /* STABLE */,
                                        __: [2]
                                    })
                                ]),
                                _createCommentVNode(" 导航菜单 "),
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                                            return _createVNode(_component_router_link, {
                                                key: item.path,
                                                to: item.path,
                                                class: _normalizeClass(["px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 no-underline", _ctx.$route.path === item.path
                                                        ? 'bg-primary-100 text-primary-700'
                                                        : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'])
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_el_icon, { class: "mr-2" }, {
                                                        default: _withCtx(() => [
                                                            (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                                        ]),
                                                        _: 2 /* DYNAMIC */
                                                    }, 1024 /* DYNAMIC_SLOTS */),
                                                    _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                                ]),
                                                _: 2 /* DYNAMIC */
                                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]);
                                        }), 64 /* STABLE_FRAGMENT */))
                                    ])
                                ]),
                                _createCommentVNode(" 用户信息/登录按钮 "),
                                _createElementVNode("div", _hoisted_7, [
                                    (_unref(authStore).isAuthenticated)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                            _createCommentVNode(" 用户头像和信息 "),
                                            _createElementVNode("div", _hoisted_9, [
                                                _createVNode(_component_el_avatar, {
                                                    src: _unref(authStore).userAvatar,
                                                    size: 32,
                                                    class: "bg-primary-500"
                                                }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_el_icon, null, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_unref(User))
                                                            ]),
                                                            _: 1 /* STABLE */
                                                        })
                                                    ]),
                                                    _: 1 /* STABLE */
                                                }, 8 /* PROPS */, ["src"]),
                                                _createElementVNode("div", _hoisted_10, [
                                                    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(authStore).userDisplayName), 1 /* TEXT */),
                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(getPermissionLevelText(_unref(authStore).permissionLevel)), 1 /* TEXT */)
                                                ])
                                            ]),
                                            _createCommentVNode(" 登出按钮 "),
                                            _createVNode(_component_el_button, {
                                                size: "small",
                                                type: "danger",
                                                onClick: handleLogout,
                                                loading: _unref(authStore).isLoading
                                            }, {
                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                    _createTextVNode(" 登出 ")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [3]
                                            }, 8 /* PROPS */, ["loading"])
                                        ]))
                                        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                            _createCommentVNode(" 未登录时显示登录按钮 "),
                                            _createVNode(_component_el_button, {
                                                type: "primary",
                                                onClick: handleLogin
                                            }, {
                                                default: _withCtx(() => _cache[4] || (_cache[4] = [
                                                    _createTextVNode("登录")
                                                ])),
                                                _: 1 /* STABLE */,
                                                __: [4]
                                            })
                                        ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                ]),
                                _createCommentVNode(" 移动端菜单按钮 "),
                                _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_component_el_button, {
                                        onClick: _cache[0] || (_cache[0] = ($event) => (mobileMenuOpen.value = !mobileMenuOpen.value)),
                                        text: ""
                                    }, {
                                        default: _withCtx(() => [
                                            _createVNode(_component_el_icon, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_unref(Menu))
                                                ]),
                                                _: 1 /* STABLE */
                                            })
                                        ]),
                                        _: 1 /* STABLE */
                                    })
                                ])
                            ])
                        ]),
                        _createCommentVNode(" 移动端菜单 "),
                        (mobileMenuOpen.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                _createElementVNode("div", _hoisted_15, [
                                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(navItems, (item) => {
                                        return _createVNode(_component_router_link, {
                                            key: item.path,
                                            to: item.path,
                                            onClick: _cache[1] || (_cache[1] = ($event) => (mobileMenuOpen.value = false)),
                                            class: _normalizeClass(["block px-3 py-2 rounded-md text-base font-medium transition-colors duration-200", _ctx.$route.path === item.path
                                                    ? 'bg-primary-100 text-primary-700'
                                                    : 'text-gray-600 hover:text-gray-900 hover:bg-gray-100'])
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_el_icon, { class: "mr-2" }, {
                                                    default: _withCtx(() => [
                                                        (_openBlock(), _createBlock(_resolveDynamicComponent(item.icon)))
                                                    ]),
                                                    _: 2 /* DYNAMIC */
                                                }, 1024 /* DYNAMIC_SLOTS */),
                                                _createTextVNode(" " + _toDisplayString(item.title), 1 /* TEXT */)
                                            ]),
                                            _: 2 /* DYNAMIC */
                                        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["to", "class"]);
                                    }), 64 /* STABLE_FRAGMENT */)),
                                    _createCommentVNode(" 移动端用户信息/登录按钮 "),
                                    _createElementVNode("div", _hoisted_16, [
                                        (_unref(authStore).isAuthenticated)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                _createCommentVNode(" 用户信息 "),
                                                _createElementVNode("div", _hoisted_18, [
                                                    _createVNode(_component_el_avatar, {
                                                        src: _unref(authStore).userAvatar,
                                                        size: 40,
                                                        class: "bg-primary-500"
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_el_icon, null, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(User))
                                                                ]),
                                                                _: 1 /* STABLE */
                                                            })
                                                        ]),
                                                        _: 1 /* STABLE */
                                                    }, 8 /* PROPS */, ["src"]),
                                                    _createElementVNode("div", null, [
                                                        _createElementVNode("p", _hoisted_19, _toDisplayString(_unref(authStore).userDisplayName), 1 /* TEXT */),
                                                        _createElementVNode("p", _hoisted_20, _toDisplayString(getPermissionLevelText(_unref(authStore).permissionLevel)), 1 /* TEXT */)
                                                    ])
                                                ]),
                                                _createCommentVNode(" 登出按钮 "),
                                                _createVNode(_component_el_button, {
                                                    type: "danger",
                                                    onClick: handleLogout,
                                                    class: "w-full",
                                                    loading: _unref(authStore).isLoading
                                                }, {
                                                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                        _createTextVNode(" 登出 ")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [5]
                                                }, 8 /* PROPS */, ["loading"])
                                            ]))
                                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                                _createCommentVNode(" 未登录时显示登录按钮 "),
                                                _createVNode(_component_el_button, {
                                                    type: "primary",
                                                    onClick: handleLogin,
                                                    class: "w-full"
                                                }, {
                                                    default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                        _createTextVNode("登录")
                                                    ])),
                                                    _: 1 /* STABLE */,
                                                    __: [6]
                                                })
                                            ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" 主要内容区域 "),
                _createVNode(_component_el_main, { class: "px-0" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_router_view, null, {
                                default: _withCtx(({ Component }) => [
                                    _createVNode(_Transition, {
                                        name: "fade",
                                        mode: "out-in"
                                    }, {
                                        default: _withCtx(() => [
                                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                                        ]),
                                        _: 2 /* DYNAMIC */
                                    }, 1024 /* DYNAMIC_SLOTS */)
                                ]),
                                _: 1 /* STABLE */
                            })
                        ])
                    ]),
                    _: 1 /* STABLE */
                }),
                _createCommentVNode(" 底部信息 "),
                _createVNode(_component_el_footer, { class: "bg-white border-t border-gray-200 text-center text-gray-500 text-sm" }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_22, [
                            _cache[8] || (_cache[8] = _createTextVNode(" © 2025 总管忖大论坛 ❤ 智能具身化学实验室 ")),
                            _createVNode(_component_el_text, { type: "primary" }, {
                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                    _createTextVNode("共同支持")
                                ])),
                                _: 1 /* STABLE */,
                                __: [7]
                            })
                        ])
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
